import {
  Pivot,
  pivotContainerStylesFill,
  pivotStylesFill,
  useToast,
  WidgetPanel,
  widgetPanelStylesNoBG,
} from '@h2oai/ui-kit';
import { useCallback, useEffect, useState } from 'react';

import { fsApi } from '../../featurestore/api';
import {
  CoreService,
  ListableFeatureSetToPermission,
  ListableProjectToPermission,
  PermissionState,
} from '../../featurestore/gen/ai/h2o/featurestore/api/v1/CoreService.pb';
import { ContentsTitle } from '../../featurestore/models';
import { getErrorMessageBarMessage, hasAPIError } from '../../featurestore/utils';
import { AccessRequest, getAccessRequestListItem } from '../AccessRequestList/AccessRequestList';
import { PendingPermissionList } from '../PendingPermissionList/PendingPermissionList';

export const PendingPermissionsWidget = () => {
  const [data, setData] = useState<{ projects: AccessRequest[]; featureSets: AccessRequest[] }>({
    projects: [],
    featureSets: [],
  });
  const [loadingMessage, setLoadingMessage] = useState('');
  const { addToast } = useToast();
  const load = useCallback(async () => {
    setLoadingMessage(`Loading pending permissions...`);
    const results = await Promise.all(
      [
        fsApi(CoreService.ListProjectPermissionsPage, {
          filters: [PermissionState.PENDING],
          pageSize: 1000,
        }),
        fsApi(CoreService.ListFeatureSetsPermissionsPage, {
          filters: [PermissionState.PENDING],
          pageSize: 1000,
        }),
      ].map((p) => p.catch((e) => e))
    );
    const resultData: { projects: AccessRequest[]; featureSets: AccessRequest[] } = {
      projects: [],
      featureSets: [],
    };
    results.forEach((d, i) => {
      if (hasAPIError(d)) {
        addToast(getErrorMessageBarMessage(d, `An error has occurred while loading pending permissions: `));
      } else {
        switch (i) {
          case 0:
            resultData.projects = d.entries.map((entry: ListableProjectToPermission) =>
              getAccessRequestListItem(entry)
            );
            break;
          case 1:
            resultData.featureSets = d.entries.map((entry: ListableFeatureSetToPermission) =>
              getAccessRequestListItem(entry)
            );
            break;
        }
      }
    });
    setData(resultData);
    setLoadingMessage('');
  }, [addToast]);
  useEffect(() => {
    load();
  }, []);
  return (
    <WidgetPanel styles={widgetPanelStylesNoBG} title="Pending Permissions" data-test="pending-permissions-widget">
      <Pivot
        styles={pivotStylesFill}
        pivotContainerStyles={pivotContainerStylesFill}
        items={[
          {
            headerText: `${ContentsTitle.projects} (${data.projects.length})`,
            content: (
              <PendingPermissionList title={ContentsTitle.projects} data={data.projects} loading={!!loadingMessage} />
            ),
          },
          {
            headerText: `${ContentsTitle.featureSets} (${data.featureSets.length})`,
            content: (
              <PendingPermissionList
                title={ContentsTitle.featureSets}
                data={data.featureSets}
                loading={!!loadingMessage}
              />
            ),
          },
        ]}
      />
    </WidgetPanel>
  );
};
